import React, { useEffect, useState } from "react";
import {
  Button,
  Card,
  Col,
  InputGroup,
  Pagination,
  Row,
} from "react-bootstrap";
import { AddRace, DeleteRaceModule, StatusModule } from "../modals/allModal";
import useDialogState from "../../hooks/useDialog";
import { useFormik } from "formik";
import * as yup from "yup";
import * as XLSX from "xlsx";
import { useLocation, useNavigate } from "react-router-dom";
import { CircularProgress, Grid, Typography } from "@mui/material";
import { enqueueSnackbar } from "notistack";
import RaceService from "../../services/race.service";
import status from "../../../assets/img/brand/checked_709510.png";
import CountryService from "../../services/country.service";
import useMenuState, { useMenuState2 } from "../../hooks/useMenuState";
import Searchable from "react-searchable-dropdown";
import { parse } from "date-fns";
import moment from "moment/moment";
import ColorCodeService from "../../services/coloeCode.service";

const Race = () => {
  const location = useLocation();
  const { search } = location;
  const selectedType = search.split("=")[1];
  const [selectedImages, setSelectedImages] = useState("");
  const [data, setData] = useState([]);
  const [update, setUpdate] = useState(false);
  const [countryData, setCountryData] = useState([]);
  const [searchText, setSearchText] = useState("");
  const [deleteRace, setDeleteRace] = useState(false);
  const [deleteId, setDeleteId] = useState("");
  const handleCloseRace = () => setDeleteRace(false);
  const [deleteName, setDeleteName] = useState("");
  const [statusChange, setStatusChange] = useState(false);
  const handleCloseStatus = () => setStatusChange(false);
  const [statusId, setStatusId] = useState("");
  const [statusName, setStatusName] = useState("");
  const [count, setCount] = useState("");
  const [pages, setPages] = useState(1);
  const [loader, setLoader] = useState(false);
  const [pageOnLoad, setPageOnLoad] = useState(false);
  const [showFilterValue, setShowFilterValue] = useState(null);
  const [statusPlayer, setStatusPlayer] = useState("");
  const [selectedDate, setSelectedDate] = useState(new Date());
  const [checkStatus, setCheckStatus] = useState("");
  const navigate = useNavigate();
  const {
    open: modalShow,
    handleClickOpen: handleDialogOpen,
    handleClose: handleDialogClose,
  } = useDialogState();
  const [colorCodeData, setColorCodeData] = useState([]);
  const [openCity, handleOpenCity, handleCloseCity] = useMenuState(false);
  const [openCity2, handleOpenCity2, handleCloseCity2] = useMenuState2(false);
  const userProfile = JSON.parse(localStorage.getItem("userProfile"));
  const [modelLoader, setModelLoader] = useState(false);

  const schema = yup.object().shape({
    raceStatus: yup.mixed().required("Please Select Race Status"),
    year: yup.string().required("Please Enter Year"),
    startingTime: yup.string().required("Please Select Match Time"),
    countryId: yup.mixed().required("Please Select Country"),
    spotifyUrl: yup.string().required("Please Enter Spotify Link").matches(/^https?:\/\/open\.spotify\.com\/.+$/, "Please Enter a valid Spotify URL"),
    data: yup.mixed().required("Please Upload Player Data"),
    isElevenQuestions: selectedType === "f1" && yup.string().required("Please Select Team"),
    raceName: yup.string().required("Please Enter Race Name"),
    colorCodeId: colorCodeData?.length > 0 ? yup.string().required("Please Select Season") : yup.string().required(`Please Add Season from Colorcode ${selectedType}.`),
  });


  const getAllData = async (page) => {
    setPageOnLoad(true);
    const response = await RaceService.GetRace(showFilterValue, page, null, selectedType?.toUpperCase());
    setPageOnLoad(false);
    setCount(response.data.totalCount);
    setData(response.data.data);
  };
  const pageSize = Math.ceil(count / 12);

  useEffect(() => {
    getAllData();
  }, [showFilterValue, selectedType]);

  const initialValue = {
    raceStatus: "",
    countryId: "",
    spotifyUrl: "",
    data: null,
    isElevenQuestions: "",
    raceName: "",
    startingTime: "",
    totalQuestion: "",
  };

  const getSeasonList = async () => {
    const response = await ColorCodeService.GetAllColorCodeSeasonName(
      selectedType?.toUpperCase()
    );

    setColorCodeData(response.data.data);
  };

  const options = [
    { label: "Yes", value: true },
    { label: "No", value: false },
  ];

  const raceStatus = [
    { label: "Active", value: "active" },
    { label: "In Active", value: "inactive" },
    { label: "Finished", value: "finished" },
  ];

  const raceFilter = [
    { label: "All", value: null },
    { label: "Active", value: "active" },
    { label: "In Active", value: "inactive" },
    { label: "Finished", value: "finished" },
  ];

  const handleTypeChange = (res) => {
    formik.setFieldValue("raceStatus", res.value);
  };

  const getCountryList = async () => {
    const response = await CountryService.GetCountryListForRace();
    setCountryData(response.data.data);
  };

  useEffect(() => {
    getCountryList();
    getSeasonList();
  }, [selectedType]);

  const contryStatus = [
    ...countryData.map((item) => ({
      value: item._id,
      label: item.countryName,
    })),
  ];

  const ColorStatus = colorCodeData.map((item) => ({
    label: item.seasonName,
    value: item._id,
  }));

  const changeCountry = (value) => {
    formik.setFieldValue("countryId", value.value);
    formik.setFieldValue("countryName", value.label);
    setSearchText(value);
  };
  const changeSeason = (value) => {
    formik.setFieldValue("colorCodeId", value.value);
  };

  const handleTypeChange2 = (res) => {
    formik.setFieldValue("type", res.value);
  };

  const handleFileUpload = async (event) => {
    const file = event.target.files[0];

    if (!file || !file.name.endsWith(".xlsx")) {
      enqueueSnackbar(
        "Invalid File Type! Only Excel files (XLSX) are allowed.",
        {
          variant: "error",
        }
      );
      return;
    }
    const reader = new FileReader();
    reader.onload = async function (e) {
      const data = new Uint8Array(e.target.result);
      const workbook = XLSX.read(data, { type: "array" });
      const sheetName = workbook.SheetNames[0];
      const sheetData = XLSX.utils.sheet_to_json(workbook.Sheets[sheetName]);
      formik.setFieldValue("data", sheetData);
    };

    reader.readAsArrayBuffer(file);
  };

  const submit = async (values, action) => {
    setModelLoader(true);
    const { totalQuestion, isElevenQuestions, ...rest } = values;
    const data = {
      ...rest,
      totalQuestion: selectedType === "moto_gp" ? 24 : totalQuestion,
      isElevenQuestions: selectedType === "moto_gp" ? false : isElevenQuestions,
      adminId: userProfile?.user?.id,
      type: selectedType?.toUpperCase(),
    };
    if (!values.raceId) {
      try {
        setLoader(true);
        await RaceService.addRace(data);
        setLoader(false);
        handleDialogClose();
        setSelectedImages(null);
        getAllData();
        action.resetForm();
      } catch (error) {
        console.error("create race error", error);
        setModelLoader(false);
        setLoader(false);
      }
    } else {
      const { totalQuestion,isElevenQuestions, ...rest } = values;
      const data = {
        ...rest,
        totalQuestion: selectedType === "moto_gp" ? 24 : totalQuestion,
        isElevenQuestions: selectedType === "moto_gp" ? false : isElevenQuestions,
        type: selectedType?.toUpperCase(),
      };
      try {
        await RaceService.UpdateRacing(values.raceId, data);
        handleDialogClose();
        setSelectedImages(null);
        getAllData();
        action.resetForm();
      } catch (error) {
        setModelLoader(false);
        console.error("create race error", error);
      }
    }
  };

  const formik = useFormik({
    initialValues: initialValue,
    validationSchema: schema,
    onSubmit: submit,
  });

  
  const formatDate = (date) => {
    return `${date}`;
  };

  const handleDateChnage = (date) => {
    const newDate = formatDate(date);
    const newDateInMilliseconds = parse(
      newDate,
      "dd-MM-yyyy HH:mm:ss",
      new Date()
    ).getTime();
    formik.setFieldValue("startingTime", newDateInMilliseconds);
  };

  const handleOpen = async (id, status) => {
    setModelLoader(false);

    handleDialogOpen();
    setCheckStatus(status);
    if (id) {
      setUpdate(true);
      const response = await RaceService.GetSingleRace(id);
      const result = response.data.data;
      formik.setFieldValue("raceId", id);
      formik.setFieldValue("raceStatus", result.raceStatus);
      formik.setFieldValue("countryId", result.countryId);
      formik.setFieldValue("isElevenQuestions", result.isElevenQuestions);
      formik.setFieldValue("totalQuestion", result.totalQuestion);
      setStatusPlayer(result.isElevenQuestions);
      formik.setFieldValue("spotifyUrl", result.spotifyUrl);
      formik.setFieldValue("year", result.year);
      formik.setFieldValue("data", result.playerDetail);
      formik.setFieldValue("colorCodeId", result.colorCodeId);
      formik.setFieldValue("raceName", result.raceName);
      const date = result.startingTime;
      const dateTime = moment(Number(date)).format("DD-MM-YYYY HH:mm");
      formik.setFieldValue("startingTime", dateTime);
    } else {
      setUpdate(false);
      formik.setFieldValue("raceStatus", "inactive");
      formik.setFieldValue("countryId", "");
      formik.setFieldValue("spotifyUrl", "");
      formik.setFieldValue("isElevenQuestions", "");
      formik.setFieldValue("totalQuestion", "");
      formik.setFieldValue("year", "");
      formik.setFieldValue("data", "");
      formik.setFieldValue("raceName", "");
      formik.setFieldValue("startingTime", "");
      formik.setFieldValue("colorCodeId", "");
    }
  };

  const handelDelete = (id, name) => {
    setDeleteRace(true);
    setDeleteId(id);
    setDeleteName(name);
  };

  const handelGetStatusChange = (id, name) => {
    setStatusChange(true);
    setStatusId(id);
    setStatusName(name);
  };

  const handleRadioChange = (value, number) => {
    formik.setFieldValue("isElevenQuestions", value);
    formik.setFieldValue("totalQuestion", number);
  };

  const handleStatusFilter = (res) => {
    setShowFilterValue(res);
  };

  const nextPage = (page) => {
    setPages(page);
    getAllData(page);
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
  };
  const previousPage = () => {
    setPages(pages - 1);
    getAllData();
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
  };

  return (
    <>
      <div className="page-header2"></div>
      <div className="row">
        <Col sm={12} md={6} lg={6} xl={3}>
          <Card className="custom-card">
            <Card.Body>
              <div className="card-order ">
                <label className="main-content-label font-weight-bold mb-3 pt-1">
                  Total Race
                </label>
                <h2 className="text-end card-item-icon card-icon">
                  <i className="mdi mdi-car icon-size float-start text-primary"></i>
                  <span className="font-weight-bold">{count}</span>
                </h2>
              </div>
            </Card.Body>
          </Card>
        </Col>

        <Col
          sm={12}
          md={6}
          lg={6}
          xl={4}
          className="ms-auto mt-auto d-flex"
          style={{ justifyContent: "end" }}>
          <div className="me-3">
            <InputGroup className="d-flex justify-content-end">
              <Searchable
                className="form-control select2 ml-0"
                value={showFilterValue}
                placeholder="All"
                notFoundText="No result found"
                noInput
                selectedVal={showFilterValue}
                options={raceFilter}
                onSelect={(e) => handleStatusFilter(e)}
                listMaxHeight={150}
              />
            </InputGroup>
          </div>
          <div className="custom-card text-end  pointer me-5">
            <Button className="text-white" onClick={() => handleOpen("")}>
              <i className="fas fa-plus"></i> &nbsp; Add Race
            </Button>
            <AddRace
              modelLoader={modelLoader}
              colorCodeData={colorCodeData}
              type={selectedType}
              show={modalShow}
              onHide={handleDialogClose}
              selectedImages={selectedImages}
              formik={formik}
              options={options}
              handleFileUpload={handleFileUpload}
              handleTypeChange2={handleTypeChange2}
              handleTypeChange={handleTypeChange}
              raceStatus={raceStatus}
              update={update}
              changeCountry={changeCountry}
              ColorStatus={ColorStatus}
              contryStatus={contryStatus}
              handleRadioChange={handleRadioChange}
              openCity={openCity}
              handleOpenCity={handleOpenCity}
              handleCloseCity={handleCloseCity}
              openCity2={openCity2}
              handleOpenCity2={handleOpenCity2}
              handleCloseCity2={handleCloseCity2}
              statusPlayer={statusPlayer}
              loader={loader}
              selectedDate={selectedDate}
              setSelectedDate={setSelectedDate}
              handleDateChnage={handleDateChnage}
              changeSeason={changeSeason}
              checkStatus={checkStatus}
            />
          </div>
        </Col>
      </div>

      {pageOnLoad ? (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            marginBottom: "50px",
          }}>
          <CircularProgress size={30} />
        </div>
      ) : (
        <Row className="row m-auto">
          {data &&
            data.map((card) => (
              <Col sm={12} md={6} lg={4} xl={4} xxl={3}>
                <Grid
                  sx={{
                    display: "flex",
                    justifyContent: {
                      sm: "center",
                      xs: "center",
                      md: "start",
                      marginBottom: "15px",
                    },
                  }}>
                  <Card
                    className="custom-card pointer"
                    style={{ height: "250px", width: "350px" }}>
                    <img
                      onClick={() => {
                        navigate(`/raceexcelupload/?type=${selectedType}`, {
                          state: {
                            id: card._id,
                            spotify: card.spotifyUrl,
                            image: card.countryImage,
                            name: card.countryName,
                            year: card.year,
                            race: card.raceName,
                            teamStatus: card.isElevenQuestions,
                            totalQuestion: card.totalQuestion,
                          },
                        });
                      }}
                      src={card.countryImage}
                      className="rounded-lg img-fit-cover pos-relative"
                      alt="img"
                    />
                    {card.raceStatus !== "active" && (
                      <button
                        style={{
                          position: "absolute",
                          bottom: 0,
                          right: 10,
                        }}
                        className="text-white ms-3 mb-2 btn btn-primary"
                        onClick={() =>
                          handelDelete(card._id, card.countryName)
                        }>
                        <i className="fas fa-trash"></i>
                      </button>
                    )}
                    <button
                      style={{
                        position: "absolute",
                        bottom: 0,
                        right: card.raceStatus === "active" ? 10 : 60,
                      }}
                      className="text-white mb-2 btn btn-primary"
                      onClick={() => handleOpen(card._id, card.raceStatus)}>
                      <i className="fa fa-pencil"></i>
                    </button>
                    <button
                      style={{
                        position: "absolute",
                        bottom: 0,
                        border: "1px solid #000",
                        right:
                          card.raceStatus === "inactive"
                            ? 110
                            : card.raceStatus === "active"
                            ? 60
                            : 110,
                        cursor:
                          card.raceStatus === "finished"
                            ? "default"
                            : "pointer",
                      }}
                      disabled={card.raceStatus === "finished"}
                      className="text-white ms-3 mb-2 btn btn-white"
                      onClick={() =>
                        handelGetStatusChange(card._id, card.raceStatus)
                      }>
                      <div style={{ display: "flex" }}>
                        <img src={status} alt="" width="20px" height="20px" />
                        <div
                          className="font-weight-bold"
                          style={{
                            color: "#000",
                            marginLeft: "5px",
                          }}>
                          {card.raceStatus === "inactive"
                            ? "In Active"
                            : card.raceStatus === "active"
                            ? "Active"
                            : card.raceStatus === "running"
                            ? "Running"
                            : card.raceStatus === "finished"
                            ? "Finished"
                            : null}
                        </div>
                      </div>
                    </button>
                    <Card.Body className="pos-absolute card-body2">
                      <div
                        className="card-order bg-000"
                        style={{ border: "1px solid #000" }}>
                        <label
                          className="main-content-label font-weight-bold mb-0 pointer"
                          style={{ border: "1px solid #000 !importan" }}>
                          {card.raceName} - {card.countryName} - {card.year}
                        </label>
                      </div>
                    </Card.Body>
                  </Card>
                </Grid>
              </Col>
            ))}
          {deleteRace && (
            <DeleteRaceModule
              show={deleteRace}
              onHide={handleCloseRace}
              id={deleteId}
              name={deleteName}
              getAllData={getAllData}
            />
          )}
          {statusChange && (
            <StatusModule
              show={statusChange}
              onHide={handleCloseStatus}
              name={statusName}
              id={statusId}
              raceStatus={raceStatus}
              getAllData={getAllData}
              openCity={openCity}
              handleOpenCity={handleOpenCity}
              handleCloseCity={handleCloseCity}
            />
          )}
        </Row>
      )}

      {count === 0 ? (
        <Typography
          sx={{ display: "flex", justifyContent: "center", marginTop: "25px" }}>
          No Records Found
        </Typography>
      ) : (
        <Pagination
          className="pagination-circle mb-0 ms-lg-3"
          style={{ justifyContent: "center" }}>
          <Pagination.Item
            onClick={() => previousPage(pages - 1)}
            disabled={pages === 1}>
            <i className="fas fa-angle-double-left"></i>
          </Pagination.Item>
          {Array.from({ length: Math.ceil(count / 12) }).map((_, index) => {
            const pageNumber = index + 1;
            return (
              <Pagination.Item
                onClick={() => nextPage(pageNumber)}
                key={pageNumber}
                active={pageNumber === pages}>
                {pageNumber}
              </Pagination.Item>
            );
          })}
          <Pagination.Item
            onClick={() => nextPage(pages + 1)}
            disabled={pageSize === pages}>
            <i className="fas fa-angle-double-right"></i>
          </Pagination.Item>
        </Pagination>
      )}
    </>
  );
};

export default Race;
